"use client";
import * as React from "react";
import { Box, SlideFade, Fade } from "@chakra-ui/react";
import MeetingContent from "../components/meeting/MeetingContent";

function MeetingsDefaultRecent() {
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    // Trigger animation after component mounts
    setIsLoaded(true);
  }, []);

  // Note: the MeetingProvider is supplied once by DashboardLayout and persists
  // across navigation. Re-wrapping here would create a second provider that
  // remounts (and refetches) on every visit, so we rely on the shared one.
  return (
    <Fade
      in={isLoaded}
      transition={{ enter: { duration: 0.3 } }}
    >
      <Box
        w="full"
        h="full"
        bg="gray.50"
        borderRadius="xl"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        position="relative"
      >
        <MeetingContent />
      </Box>
    </Fade>
  );
}

export default MeetingsDefaultRecent;
